module.exports = __webpack_public_path__ + "media/alert.bc6dd643.mp3";